var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateGroup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 4.266,
    height: 7.11,
    viewBox: "0 0 4.266 7.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#005386",
    d: "M331.93,474.224a.484.484,0,0,1-.153.352l-3.218,3.057a.544.544,0,0,1-.741,0,.481.481,0,0,1,0-.7l2.848-2.705-2.848-2.705a.481.481,0,0,1,0-.7.544.544,0,0,1,.741,0l3.218,3.057A.484.484,0,0,1,331.93,474.224Z",
    transform: "translate(-327.664 -470.669)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateGroup);
export default __webpack_public_path__ + "static/media/createGroup.494a87775d94ec4050cc873083e94ff2.svg";
export { ForwardRef as ReactComponent };